<template>
    <v-app id="inspire">
        <v-layout row justify-center>
            <v-dialog v-model="onShow" persistent max-width="65%">
                <v-card>
                    <v-card-title>
                        <span class="subheading">MARS - Assign pools to pool group: {{ poolGroup.name }}</span>
                    </v-card-title>

                    <v-divider></v-divider>


                    <v-layout wrap>
                        <v-container id="scroll-target" style="max-height: 70%" class="scroll-y" v-if="editMode">
                            <v-data-table :headers="headers"
                                          :items="poolGroupAssignmentList" hide-actions>
                                <template slot="headers" slot-scope="props">
                                    <tr>
                                        <th v-for="header in props.headers" v-bind:key="header.value"
                                            class="subheading congatec-gray text-xs-left">
                                            {{header.text}}
                                        </th>
                                    </tr>
                                </template>
                                <template slot="items" slot-scope="props">
                                    <td>
                                        <v-checkbox :id="'pool_group_assignment_checkbox_' + props.index"
                                                    :value="props.item.poolAssigned"
                                                    :key="props.item.pool.poolId"
                                                    v-model="props.item.poolAssigned"
                                                    :disabled="disabled"
                                                    @click.native="onAssignPoolToGroup(props.item)"></v-checkbox>
                                    </td>
                                    <td class="text-xs-left">{{ props.item.pool.name}}</td>
                                    <td class="text-xs-left">{{ props.item.pool.description}}</td>
                                    <td v-if="props.item.pool.isActive" class="text-xs-left">
                                        <v-icon color="green" small>fas fa-circle</v-icon>
                                    </td>
                                    <td v-else class="text-xs-left">
                                        <v-icon color="red" small>fas fa-circle</v-icon>
                                    </td>
                                    <td class="text-xs-left">{{ props.item.pool.oui}}</td>
                                    <td class="text-xs-left">{{ props.item.pool.startMac}}</td>
                                    <td class="text-xs-left">{{ props.item.pool.endMac}}</td>
                                </template>
                            </v-data-table>
                        </v-container>
                    </v-layout>

                    <v-alert :value="error" type="error" transition="scale-transition">
                        {{ errorMessage }}
                    </v-alert>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn id="save_pool_group_assignment_button" class="text-none" color="green" small dark
                               @click="savePoolGroupAssignments"
                               :disabled="disabled">
                            Save
                        </v-btn>
                        <v-btn id="cancel_pool_group_assignment_button" class="text-none" small @click="close">Cancel
                        </v-btn>
                    </v-card-actions>

                </v-card>
            </v-dialog>
        </v-layout>
    </v-app>

</template>

<script>

    import poolgroupassignmentinterface from "../../../interfaces/poolgroupassignmentinterface";
    import {EventBus} from "../../../eventbus";
    import errormessagemanager from "../../../managers/errormessagemanager";

    export default {
        name: 'AssignPoolToPoolGroupModal',

        data: () => ({
            headers: [
                {text: '', value: 'poolAssigned', sortable: false},
                {text: 'Name', value: 'name'},
                {text: 'Description', value: 'description'},
                {text: 'Is active', value: 'isActive'},
                {text: 'OUI', value: 'oui'},
                {text: 'Start MAC', value: 'startMac'},
                {text: 'End MAC', value: 'endMac'},
            ],

            changedPoolGroupAssignments: [],

            error: false,
            errorMessage: null
        }),

        props: {
            value: Boolean,
            editMode: Boolean,
            disabled: Boolean,
            width: String,

            poolGroupAssignmentList: Array,

            poolGroup: {
                poolGroupId: Number,
                name: String,
                description: String,
                pools: Array
            }
        },

        computed: {
            getTitle: function () {
                return this.editMode ? "Edit" : "Create";
            },

            onShow: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        methods: {
            async savePoolGroupAssignments() {
                this.clearAlert();

                if (this.changedPoolGroupAssignments != null && this.changedPoolGroupAssignments.length > 0) {
                    for (const changedPoolGroupAssignment of this.changedPoolGroupAssignments) {
                        let res = null;

                        if (changedPoolGroupAssignment.poolAssigned) {
                            await poolgroupassignmentinterface.postPoolGroupAssignment(changedPoolGroupAssignment, responseObject => {
                                res = responseObject;
                            });
                        } else {
                            await poolgroupassignmentinterface.deletePoolGroupAssignment(changedPoolGroupAssignment, responseObject => {
                                res = responseObject;
                            });
                        }

                        if (res != null && res.error) {
                            this.error = res.error;
                            errormessagemanager.getUpdateErrorMessage(res.status, message => {
                                this.errorMessage = message;
                            });
                        } else if (!this.error) {
                            await this.close();
                        }
                    }
                }
            },

            onAssignPoolToGroup(item) {
                let containedIndex = -1;

                this.changedPoolGroupAssignments.forEach(assignment => {
                    if (assignment.pool != null && item.pool != null && assignment.pool.poolId === item.pool.poolId) {
                        containedIndex = this.changedPoolGroupAssignments.indexOf(assignment);
                    }
                });

                if (containedIndex !== -1) {
                    this.changedPoolGroupAssignments.splice(containedIndex, 1);
                } else {
                    this.changedPoolGroupAssignments.push(item)
                }
            },

            async close() {
                await EventBus.$emit('poolGroupAssignmentModalClosed');
                this.onShow = false;

                this.clearData();
                this.clearAlert();
            },

            clearData() {
                this.poolGroup.poolGroupId = null;
                this.poolGroup.name = null;
                this.poolGroup.description = null;

                this.changedPoolGroupAssignments = [];

                this.$validator.errors.clear();
                this.$validator.fields.items.forEach(field => field.reset());
                this.$validator.fields.items.forEach(field => this.errors.remove(field));
                this.$validator.resume();
            },

            clearAlert() {
                this.error = false;
                this.errorMessage = null;
            }
        }
    };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/poolgroups/modals/AssignPoolToPoolGroupModal.vue